import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { categories } from '@/mocks/homeData';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-white/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <nav className="container-custom flex items-center justify-between h-16 md:h-18">
        <Link
          to="/"
          className="flex items-center gap-2 group"
          aria-label="日本在线观看 首页"
        >
          <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center bg-primary-500 text-white rounded-lg group-hover:bg-primary-600 transition-colors">
            <i className="ri-play-circle-fill text-xl md:text-2xl"></i>
          </div>
          <span className={`font-serif font-bold text-lg md:text-xl whitespace-nowrap transition-colors ${
            scrolled ? 'text-foreground-900' : 'text-white'
          }`}>
            日本在线观看
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          <Link
            to="/"
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
              location.pathname === '/'
                ? scrolled ? 'bg-background-100 text-primary-600' : 'bg-white/20 text-white'
                : scrolled ? 'text-foreground-700 hover:text-primary-600 hover:bg-background-100' : 'text-white/80 hover:text-white hover:bg-white/10'
            }`}
          >
            首页
          </Link>
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname.includes(`/category/${cat.slug}`)
                  ? scrolled ? 'bg-background-100 text-primary-600' : 'bg-white/20 text-white'
                  : scrolled ? 'text-foreground-700 hover:text-primary-600 hover:bg-background-100' : 'text-white/80 hover:text-white hover:bg-white/10'
              }`}
            >
              {cat.name}
            </Link>
          ))}
          <Link
            to="/articles"
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
              location.pathname.startsWith('/article')
                ? scrolled ? 'bg-background-100 text-primary-600' : 'bg-white/20 text-white'
                : scrolled ? 'text-foreground-700 hover:text-primary-600 hover:bg-background-100' : 'text-white/80 hover:text-white hover:bg-white/10'
            }`}
          >
            影视资讯
          </Link>
          <Link
            to="/about"
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
              location.pathname === '/about'
                ? scrolled ? 'bg-background-100 text-primary-600' : 'bg-white/20 text-white'
                : scrolled ? 'text-foreground-700 hover:text-primary-600 hover:bg-background-100' : 'text-white/80 hover:text-white hover:bg-white/10'
            }`}
          >
            关于我们
          </Link>
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors ${
            scrolled ? 'text-foreground-900 hover:bg-background-100' : 'text-white hover:bg-white/10'
          }`}
          aria-label="打开菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-white border-t border-background-200 shadow-lg">
          <div className="container-custom py-4 flex flex-col gap-1">
            <Link to="/" className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-900 hover:bg-background-100 transition-colors">首页</Link>
            {categories.map((cat) => (
              <Link key={cat.slug} to={`/category/${cat.slug}`} className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-900 hover:bg-background-100 transition-colors">{cat.name}</Link>
            ))}
            <Link to="/articles" className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-900 hover:bg-background-100 transition-colors">影视资讯</Link>
            <Link to="/about" className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-900 hover:bg-background-100 transition-colors">关于我们</Link>
          </div>
        </div>
      )}
    </header>
  );
}